const Gallery = () => {
  const galleryImages = [
    {
      src: "https://images.unsplash.com/photo-1767500536251-e9781c0b5eb5?crop=entropy&cs=srgb&fm=jpg&w=600&h=700&fit=crop",
      alt: "Tabla de ibéricos de bellota Sevilla Este",
      tall: true,
    },
    {
      src: "https://images.unsplash.com/photo-1541014741259-de529411b96a?w=600&h=400&fit=crop",
      alt: "Montaditos gourmet Sevilla Este",
      tall: false,
    },
    {
      src: "https://abaceriacomoencasa.com/montadito.jpeg?w=600&h=700&fit=crop",
      alt: "Carnes a la brasa Sevilla Este",
      tall: false,
    },
    {
      src: "https://images.unsplash.com/photo-1765033670303-3a1d62ae5cbd?w=600&h=700&fit=crop",
      alt: "Vinos seleccionados Sevilla Este",
      tall: true,
    },
    {
      src: "https://images.unsplash.com/photo-1672833634993-a7ce02f7adbc?w=600&h=400&fit=crop",
      alt: "Tapear en Sevilla Este con amigos",
      tall: false,
    },
    {
      src: "https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=600&h=400&fit=crop",
      alt: "Mariscos frescos Sevilla Este",
      tall: false,
    },
    {
      src: "https://images.unsplash.com/photo-1761062083136-dcfbd2a000f9?w=600&h=700&fit=crop",
      alt: "Restaurante Sevilla Este Abacería Como en Casa",
      tall: true,
    },
    {
      src: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=600&h=400&fit=crop",
      alt: "Cata de vinos Sevilla Este",
      tall: false,
    },
    {
      src: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&h=400&fit=crop",
      alt: "Tapas mercado de abastos Sevilla Este",
      tall: false,
    },
  ];

  return (
    <section className="section-padding bg-[#F9F7F2]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="font-accent text-[#800020] text-lg mb-4">
            Momentos
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] mb-4">
            Galería Gastronómica
          </h2>
          <p className="font-body text-[#1A1A1A]/70 max-w-2xl mx-auto">
            Descubre nuestra cocina a través de imágenes
          </p>
        </div>

        {/* Masonry Gallery */}
        <div className="gallery-masonry">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="img-zoom group relative overflow-hidden"
              data-testid={`gallery-image-${index}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className={`w-full object-cover ${
                  image.tall ? "h-[400px]" : "h-[250px]"
                }`}
              />
              {/* Hover overlay */}
              <div className="absolute inset-0 bg-[#800020]/0 group-hover:bg-[#800020]/30 transition-colors duration-300 flex items-center justify-center">
                <span className="font-body text-white text-sm uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {image.alt}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Instagram CTA */}
        <div className="text-center mt-12">
          <a
            href="https://instagram.com/abaceriacomoencasa"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-link"
            className="inline-flex items-center gap-2 font-body text-[#800020] hover:text-[#600018] transition-colors"
          >
            <svg
              className="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                clipRule="evenodd"
              />
            </svg>
            <span className="uppercase tracking-widest text-sm">
              Síguenos en Instagram @abaceriacomoencasa
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
